import './bootstrap';
import 'vue-toast-notification/dist/theme-default.css';
import '../scss/app.scss';

import { base as baseHelper } from '@/helpers/base.js';

import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';

import { useToast } from 'vue-toast-notification';

const IndexGuest = defineAsyncComponent(() => import('@/components/Pages/Index/IndexGuest.vue'));
const IndexAuthed = defineAsyncComponent(() => import('@/components/Pages/Index/IndexAuthed.vue'));
const Referral = defineAsyncComponent(() => import('@/components/Pages/Referral.vue'));
const Profile = defineAsyncComponent(() => import('@/components/Pages/Profile.vue'));
const TrinkaGame = defineAsyncComponent(() => import('@/components/Pages/TrinkaGame.vue'));

import { useBroadcastStore } from '@/stores/broadcastStore';

window.toast = useToast();
window.baseHelper = baseHelper;

const app = createApp({});
app.use( createPinia() );

app.component('index-guest', IndexGuest);
app.component('index-authed', IndexAuthed);
app.component('referral', Referral);
app.component('profile', Profile);
app.component('trinka-game', TrinkaGame);

app.mount('#app');

// Initialize broadcast store and subscribe to balance updates
const broadcastStore = useBroadcastStore();
broadcastStore.init();
broadcastStore.subscribeBalance();
